export const TRIAL_CAMPAIGN_ID = 'trial1000' as const
export const TRIAL_VARIETY = 'hitomebore' as const
export const TRIAL_AMOUNT = 1000 as const

export const HOLD_TTL_MINUTES = 15 as const
export const DAILY_ALLOCATION_CAPACITY_DEFAULT = 84 as const
export const DEFERRAL_LIMIT_BUSINESS_DAYS = 5 as const
export const SHIPPING_TO_DELIVERY_DAYS = 1 as const
export const DELIVERY_WINDOW_DAYS = 3 as const
export const CYCLE_CUTOFF_LEAD_DAYS = 6 as const
export const NOTICE_LEAD_DAYS = 3 as const
export const CYCLE_PAYMENT_MAX_ATTEMPTS = 4 as const
export const CYCLE_RETRY_INTERVAL_HOURS = 24 as const
export const SHIPPING_FEE_YEN = 600 as const
// 課金成功の通算がこの回数に達した回から継続価格（repeat_price）
export const REPEAT_PRICE_FROM_COUNT = 3 as const

export const TRIAL_BROWN_RICE_BASE_GRAMS = 3300 as const
export const BROWN_RICE_EQ_COEFFICIENTS = {
  brown: 1,
  white: 1.1,
  rinse_free: 1.12,
} as const

export const BROWN_RICE_EQ_GRAMS = {
  brown: Math.round(
    TRIAL_BROWN_RICE_BASE_GRAMS * BROWN_RICE_EQ_COEFFICIENTS.brown,
  ),
  white: Math.round(
    TRIAL_BROWN_RICE_BASE_GRAMS * BROWN_RICE_EQ_COEFFICIENTS.white,
  ),
  rinse_free: Math.round(
    TRIAL_BROWN_RICE_BASE_GRAMS * BROWN_RICE_EQ_COEFFICIENTS.rinse_free,
  ),
} as const

export const JP_HOLIDAYS: ReadonlySet<string> = new Set([
  // 2026年（令和8年）
  '2026-01-01',
  '2026-01-12',
  '2026-02-11',
  '2026-02-23',
  '2026-03-20',
  '2026-04-29',
  '2026-05-03',
  '2026-05-04',
  '2026-05-05',
  '2026-05-06',
  '2026-07-20',
  '2026-08-11',
  '2026-09-21',
  '2026-09-22',
  '2026-09-23',
  '2026-10-12',
  '2026-11-03',
  '2026-11-23',
  // 2027年（令和9年）
  '2027-01-01',
  '2027-01-11',
  '2027-02-11',
  '2027-02-23',
  '2027-03-21',
  '2027-03-22',
  '2027-04-29',
  '2027-05-03',
  '2027-05-04',
  '2027-05-05',
  '2027-07-19',
  '2027-08-11',
  '2027-09-20',
  '2027-09-23',
  '2027-10-11',
  '2027-11-03',
  '2027-11-23',
])

export const MAIL_MAX_ATTEMPTS = 5 as const
export const MAIL_BACKOFF = {
  baseMinutes: 5,
  multiplier: 2,
} as const
export const OUTBOX_LEASE_MINUTES = 10 as const
export const PAYMENT_INQUIRY_AFTER_MINUTES = 5 as const
export const PAYMENT_STUCK_ALERT_HOURS = 24 as const

export const OPS_ALERT_RECIPIENTS = [
  // TODO(確定): 9232さんの正式な運用宛先へ置き換える。
  '9232@brickhouse.co.jp',
  // TODO(確定): ヤッキーさんの正式な運用宛先へ置き換える。
  '8kyama@gmail.com',
] as const
export const PRICE_CONFIRMATION_ALERT_START_JST = '09-15T06:00:00+09:00' as const
export const CROP_YEAR_AUTO_CONFIRM_DEADLINE_JST = '09-21T23:59:00+09:00' as const

export const RECEIPT_ISSUER = {
  name: '五十嵐商会',
  registrationNumber: 'T2370001002584', // 国税庁公表サイトで登録確認済み（2026-08-29・登録日 2023-10-01）
} as const
